import { every, get } from 'lodash';

export default function waypointsPerformed(tabData, options) {
  const waypoints = get(tabData, options.path);
  return every(
    waypoints,
    (waypoint) => waypoint.coords !== '' && waypoint.coords != null
  );
}
